
import { Product } from "@/types/product";

export const hdbasetReceivers: Product[] = [
  {
    id: "dxe-cat-rx1-4k",
    groupId: "hdbaset",
    name: "DXE-CAT-RX1-4K",
    description: "About\n\nThe DXE-CAT-RX1-4K is the receiver unit for the expanding Digital XTreme Series. The DXE-CAT-RX1-4K improves functionality while maintaining a very competitive advantage. The DXE-CAT receiver is unique as it not only has all connectors on one side for easier and cleaner integration, but also offers additional features not found on competing units in this class. In addition to HDMI reception, bi-directional IR and RS-232 functionality is included for complete control options. This device was made to be paired with the DXE-CAT transmitter to create a complete solution.\n\nThe receiver includes connectors for 1x HDMI, 1x HDBaseT (RJ-45), bidirectional 3.5mm TRS IR, bidirectional 3.5mm TRS RS-232, and a power connector. The HDBaseT port is connected to the HDBaseT port of the transmitter unit and works over a single CAT cable (5e/6/6a/7) at distances up to 230ft (70m) for 4K, and 330ft (100m) for 1080p 60Hz. All audio and video features are automatically supported as they pass through the extender.\n\nPower can be supplied to the unit from the included 24v DC wall supply, or through PoE (Power over Ethernet) from the DXE-CAT transmitter. The DXE-CAT-RX1-4K is compact and can be mounted in various locations. Every DXE-CAT-RX1-4K is built to the exceptional standards customers have come to expect from Aurora.\n\nAll DXE-CAT products conform to the HDBaseT Alliance guidelines and are fully compatible with other HDBaseT-compliant devices.",
    features: [
      "Receive HDMI up to 4K 30Hz 4:4:4 (230ft) over one CAT6 cable",
      "4K UHD Resolution",
      "All connectors on one side for easier installation",
      "Bi-directional RS-232 & IR",
      "Powered directly from transmitter via PoE",
      "Status LED for all connections on front",
      "Multiple mounting options"
    ],
    specifications: [
      "Video Distance (CAT5e/6/6a/7): 230ft (70m) 4K/330ft (100m) 1080p",
      "Video Bandwidth: 10.2Gbps",
      "Video Support: 4K 30Hz RGB/4:4:4 8-bit",
      "HDCP Compliance: Yes",
      "Audio Support: All HDMI Embedded Audio, Including Dolby TrueHD, Dolby Digital Plus and DTS-HD Master Audio transmission",
      "IR without LXC: 30k-60kHz",
      "IR Output with LXC: 30Hz-100kHz",
      "IR Input with LXC: 30k-60kHz",
      "RS-232: Bi-Directional 115k Baud Rate",
      "Front LED Status: Power, Status, HDMI, HDBaseT, RS-232 TX/RX, IR In/Out",
      "Front Selections: Reset",
      "HDBaseT Connector: RJ-45 WE/SS 8P8C",
      "RS-232 Connector: 3.5mm TRS",
      "IR Connector: 3.5mm TRS (Auto Sensing Direction for Blaster or Receiver)",
      "HDMI Connector: Type A 19 pin",
      "Power Connector: 2.1/5.5mm DC Single",
      "Mechanical: Mounting Size 1RU ½ Rack Width",
      "Dimensions [L x W x H]: 120mm x 77mm x 27.94mm [4.72\" x 3.03\" x 1.1\"]",
      "Weight: 395g [14 oz]",
      "Power Supply: 24v DC (External - Not Included) or PoE from transmitter",
      "Power Consumption: 7 Watts [max]",
      "Operation Temperature: 0~40°C [32~104°F]",
      "Storage Temperature: -20~60°C [-4~140°F]",
      "Relative Humidity: 20~90% RH [No Condensation]"
    ],
    images: [
      "/lovable-uploads/5f3cc29f-b760-45f3-8379-dc5b8d6c8ff6.png",
      "/lovable-uploads/a25bb6fc-6fed-4220-8202-21ab1d901d33.png"
    ],
    image: "/lovable-uploads/5f3cc29f-b760-45f3-8379-dc5b8d6c8ff6.png",
    slug: "dxe-cat-rx1-4k"
  },
  {
    id: "dxe-cat-rx2-4k",
    groupId: "hdbaset",
    name: "DXE-CAT-RX2-4K",
    description: "About\n\nThe DXE-CAT-RX2-4K is part of Aurora's growing Digital Xtreme Series. The DXE-CAT-RX2-4K HDBaseT™ receiver has improved features and functionality while maintaining a competitive advantage. The DXE-CAT-RX2-4K is unique as it not only has all connectors on one side for easier and cleaner integration, but also offers additional features not found on units in this class. In addition to HDMI reception, bi-directional IR, RS-232 control functionality, and dual 100BaseT LAN ports are included for complete options. The DXE-CAT-RX2-4K has ultra-low latency for crisp video quality without motion artifacts.\n\nPower can be supplied to the unit from the included wall supply (Not included with some models) or through PoH (Power over HDBaseT™) from DXE-CAT transmitters with power connected to them. This eliminates the need for external power sources at either the transmitter or receiver locations. The DXE-CAT-RX2-4K can be paired with the DXE-CAT-TX2-4K for typical HDMI point-to-point systems.\n\nIndustry standard HDBaseT™ technology and low power, this unit has a compact enclosure for attachment to projectors, or under tables, and can also be rack-mounted with an optional accessory. Every DXE-CAT-RX2-4K is built to the exceptional standards customers have come to expect from Aurora.",
    features: [
      "Receive HDMI up to 4K 30Hz 4:4:4 (230ft) over one CAT cable",
      "HDMI 1.4, 3D & 4K UHD Resolution Support",
      "All Connectors on one side for cleaner installation",
      "Dual 100Mbps LAN Ports",
      "Bi-directional RS-232 & IR",
      "PoH (Receive power from Transmitter)",
      "Status LEDs for all connections"
    ],
    specifications: [
      "Video Distance (CAT 5e/6/6a/7): 230ft (70m) 4K/330ft (100m) 1080p",
      "Video Bandwidth: 10.2Gbps",
      "Video Support: 4K 30Hz RGB/YCC 4:4:4 8-bit",
      "HDCP Compliance: Yes",
      "Audio Support: All HDMI Embedded Audio, Including Dolby TrueHD, Dolby Digital Plus and DTS-HD Master Audio transmission",
      "IR without LXC: 30k-60kHz",
      "IR Output with LXC: 30-100kHz",
      "IR Input with LXC: 30k-60kHz",
      "RS-232: Bi-Directional 115k Baud Rate",
      "LAN: 2x 100BaseT",
      "Front LED Status: Power, Status, HDMI, HDBaseT, IR In/Out, RS-232 TX/RX",
      "Front Selections: Reset, Setup",
      "HDBaseT Connector: RJ-45 WE/SS 8P8C",
      "RS-232 Connector: 3.5mm TRS",
      "IR Connector: 3.5mm TRS (Auto Sensing Direction for Blaster or Receiver)",
      "HDMI Connector: Type A 19 pin",
      "LAN Connector: RJ-45",
      "Power Connector: 2.1/5.5mm DC Jack, Locking",
      "Mechanical: Mounting Size 1RU ½ Rack Width",
      "Dimensions [L x W x H]: 120mm x 77mm x 27.94mm [4.72\" x 3.03\" x 1.1\"]",
      "Weight: 395g [14 oz]",
      "Power Supply: 24v DC 15 Watt (Not Included with some models)",
      "Power Consumption: 7 Watts [max]",
      "Operation Temperature: 0~40°C [32~104°F]",
      "Storage Temperature: -20~60°C [-4~140°F]",
      "Relative Humidity: 20~90% RH [No Condensation]"
    ],
    images: [
      "/lovable-uploads/8cf28d94-af64-4eb8-9e06-7a77491d0a79.png",
      "/lovable-uploads/67118b8a-92bc-4db8-8a72-53d9082987e0.png"
    ],
    image: "/lovable-uploads/8cf28d94-af64-4eb8-9e06-7a77491d0a79.png",
    slug: "dxe-cat-rx2-4k"
  }
];
